import { Link } from '@tanstack/react-router';

import type { BatchSearchImpactSummary } from '~/features/catalog-operations/types/search-impact.types';

interface Props {
  batchId: string;
  summary: BatchSearchImpactSummary;
}

const pct = (n: number) => `${String(Math.round(n * 100))}%`;

/** "This batch" strip: how much of the batch's addressable search volume its content covers. */
export function SearchImpactBatchStrip({ batchId, summary }: Props) {
  return (
    <div
      className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border bg-white px-5 py-3.5 text-sm shadow-sm"
      data-testid="search-impact-batch-strip"
    >
      <p className="min-w-0">
        <span className="text-muted-foreground mr-3 text-[11px] font-semibold tracking-wider uppercase">
          This batch
        </span>
        <b className="font-semibold" data-testid="search-impact-batch-strip-products-value">
          {summary.productCount.toLocaleString('en-US')} products
        </b>
        <span className="text-muted-foreground"> · </span>
        <b className="font-semibold" data-testid="search-impact-batch-strip-covered-value">
          {pct(summary.coveredPctAfter)}
        </b>{' '}
        of addressable search volume covered, up from {pct(summary.coveredPctBefore)}
      </p>
      <Link
        to="/catalog-operations/$batchId"
        params={{ batchId }}
        data-testid="search-impact-batch-strip-open-batch-link"
        className="text-primary cursor-pointer text-sm font-semibold hover:underline"
      >
        Open batch ›
      </Link>
    </div>
  );
}
